import { c as _c } from "react/compiler-runtime";
import type { ShortContactDataProps } from "forms/fields/ContactData/types";
import parseDictionary from "forms/helpers/parseDictionary";
import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { predefinedFields } from "types/predefinedFields";
interface UseContactDataProps extends Pick<ShortContactDataProps, "allOf"> {}
export default function useContactData(props) {
  const $ = _c(11);
  const {
    register,
    unregister
  } = useFormContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      name: predefinedFields.country
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const country = useWatch(t0);
  const getRegionDictionary = _temp;
  let t1;
  if ($[1] !== country || $[2] !== props.allOf) {
    t1 = getRegionDictionary({
      value: country,
      allOf: props.allOf
    });
    $[1] = country;
    $[2] = props.allOf;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const regionDictionary = t1;
  let t2;
  let t3;
  if ($[4] !== regionDictionary || $[5] !== register || $[6] !== unregister) {
    t2 = () => {
      if (regionDictionary) {
        register(predefinedFields.region);
      } else {
        unregister(predefinedFields.region);
      }
    };
    t3 = [register, unregister, regionDictionary];
    $[4] = regionDictionary;
    $[5] = register;
    $[6] = unregister;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== regionDictionary) {
    t4 = {
      regionDictionary
    };
    $[9] = regionDictionary;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(t0) {
  const {
    allOf,
    value
  } = t0;
  if (!value) {
    return null;
  }
  const item = allOf.find(i => {
    const constValue = i.if?.properties?.[predefinedFields.country]?.const;
    return Number(constValue) === Number(value);
  });
  if (item) {
    return parseDictionary({
      enumValues: item.then.properties?.[predefinedFields.region].enum,
      enumNames: item.then.properties?.[predefinedFields.region]["x-enumNames"]
    });
  }
  return null;
}